import { useState } from "react";
import { Button } from "@altimateai/lego";
import { IconCalendarTime } from "@tabler/icons-react";
import { useAppState } from "@/modules/app/useAppContext";
import ScheduleDialog from "./ScheduleDialog";

const ViewAllSchedulesButton = () => {
  const { enableStudioScheduledReports } = useAppState();
  const [scheduleDialogOpen, setScheduleDialogOpen] = useState(false);

  if (!enableStudioScheduledReports) return null;

  return (
    <>
      <Button
        variant="ghost"
        size="icon"
        title="View all schedules"
        aria-label="View all schedules"
        onClick={() => setScheduleDialogOpen(true)}
      >
        <IconCalendarTime size={18} />
      </Button>
      <ScheduleDialog
        open={scheduleDialogOpen}
        onOpenChange={setScheduleDialogOpen}
        initialView="list"
      />
    </>
  );
};

export default ViewAllSchedulesButton;
